export const fullScript = `https://scripts.sirv.com/sirvjs/v3/sirv.js`
export const componentScript = `https://scripts.sirv.com/sirvjs/v3/sirv.js`
export const scriptFullKey = 'Full'
export const scriptSelectiveKey = 'Selective'

export const getScript = (type, components) => {
  const modules = components.length ? `?modules=${components}` : ''
  if (type === scriptSelectiveKey) {
    return `<script src="https:\/\/scripts.sirv.com\/sirvjs\/v3\/sirv.js${modules}"><\/script>`
  }
  return '<script src="https:\/\/scripts.sirv.com\/sirvjs\/v3\/sirv.js"><\/script>'
}
